import { render, staticRenderFns } from "./AlertDisplayModal.vue?vue&type=template&id=cdb510b4"
import script from "./AlertDisplayModal.vue?vue&type=script&lang=js"
export * from "./AlertDisplayModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports